import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export default function ResponsiveDialog(props) {
  let {
    open,
    onClose,
    onSave,
    cancel,
    save,
    title,
    extraButtons = null,
  } = props;
  save === undefined && (save = 'ذخیره');
  cancel === undefined && (cancel = 'بستن');
  title === undefined && (title = '');

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const handleClose = () => {
    onClose();
  };
  const handleSave = () => {
    onSave();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        <DialogContent>{props.children}</DialogContent>
        <DialogActions>
          {extraButtons ? extraButtons : null}
          {!!cancel && (
            <Button
              autoFocus
              onClick={handleClose}
              variant="text"
              color="primary"
            >
              {cancel}
            </Button>
          )}
          {!!save && (
            <Button
              onClick={handleSave}
              variant="contained"
              color="secondary"
              autoFocus
            >
              {save}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
